import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(application => application.id == id),
    loading: state => state.loading,
    forOpportunity: state => id => {
      return state.all.find(application => _.get(application, 'opportunity.id') === id)
    },
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, applications) {
      state.all = applications.map(app => Object.assign(app, { loading: false }))
      state.loading = false
    },
    set(state, application) {
      state.all = state.all.filter(o => o.id != application.id)
      state.all.push(application)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    },
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('candidate/applications')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    fetch({ commit, getters }, id = Vue.$route.params.id) {
      const application = getters.find(id)

      if (application) {
        commit('set', Object.assign(application, { loading: true }))
      } else {
        commit('set', { id, loading: true })
      }

      return Vue.$http
        .get(`candidate/applications/${id}`)
        .then(response => commit('set', Object.assign(response.data, { loading: false })))
    },
    update({ commit }, application) {
      return Vue.$http.patch(`candidate/applications/${application.id}`, { application }).then(
        response => {
          commit('set', response.data)
          commit(
            'snackbar',
            {
              text: 'Locations have been updated',
              type: 'success',
            },
            { root: true }
          )
        },
        response =>
          commit(
            'snackbar',
            {
              text: 'There was a aproblem updating your locations',
              type: 'error',
            },
            { root: true }
          )
      )
    },

    archive({ commit }, application) {
      // Set loading
      commit('set', Object.assign(application, { loading: true }))

      return Vue.$http.patch(`candidate/applications/${application.id}/archive`, {}).then(
        // Success
        response => {
          commit('set', Object.assign(response.data, { loading: false }))
          this.dispatch('snackbarSuccess', 'Application Archived')
        },
        // Failure
        () => {
          commit('set', Object.assign(application, { loading: false }))
          this.dispatch(
            'snackbarError',
            'Unfortunately you could not withdraw your application for this opportunity'
          )
        }
      )
    },
    // withdraw({ commit }, application) {
    //   // Set loading
    //   commit('set', Object.assign(application, { loading: true }))

    //   return Vue.$http.post(`candidate/applications/${application.id}/withdraw`, {}).then(
    //     // Success
    //     response => {
    //       commit('set', Object.assign(response.data, { loading: false }))
    //       commit(
    //         'snackbar',
    //         {
    //           text: 'You have successfully withdrawn your application for this opportunity',
    //           type: 'success'
    //         },
    //         { root: true }
    //       )
    //     },
    //     // Failure
    //     () => {
    //       commit('set', Object.assign(application, { loading: false }))
    //       commit(
    //         'snackbar',
    //         {
    //           text: 'Unfortunately you could not withdraw your application for this opportunity',
    //           type: 'error'
    //         },
    //         { root: true }
    //       )
    //     }
    //   )
    // }
  },
}
